import sabrinaPic from "@/public/images/artists/sabrina.png";
import { Artist } from "@/types/types";

export const sabrina = {
  id: "30",
  name: "Sabrina",
  image: sabrinaPic,
  description: `Introducing "Sabrina," the quirky pop sensation who's breaking the mold. With a voice that's equal parts playful and powerful, Sabrina adds a refreshing twist to the pop music landscape. Her unique style and infectious energy make every song a delightful adventure.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fsabrina-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Female",
    tags: {
      primary: ["Pop"],
      secondary: ["Singer", "Quirky", "Playful"],
    },
    pitchRange: {
      categories: {
        low: "Mid",
        high: "Mid",
      },
      specific: {
        low: 56,
        high: 68,
      },
    },
  },
} as const satisfies Artist;
